// extracted by mini-css-extract-plugin
module.exports = {"main":"PublicProfilesGhostBox_main__6_yFE","text":"PublicProfilesGhostBox_text___wN8j"};